import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const UnsavedChangesModal = ({ show, onKeepEditing, onDiscardChanges }) => {
  const { t } = useTranslation()

  return (
    <Modal
      show={show}
      onClose={onKeepEditing}
      title={t('Cambios sin guardar')}
      size="l"
      actions={
        <Styles.Actions>
          <Button fullWidth variant="outlined" onClick={onDiscardChanges}>
            {t('Descartar cambios')}
          </Button>
          <Button fullWidth onClick={onKeepEditing}>
            {t('Seguir editando')}
          </Button>
        </Styles.Actions>
      }
    >
      <Text type="bodyMRegular">
        {t('Tienes cambios sin guardar que se perderán si sales. ¿Seguro que quieres continuar?')}
      </Text>
    </Modal>
  )
}

export default UnsavedChangesModal
